<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col
        cols="11"
        class="mx-auto"
      >
        <p 
          :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'"
        >
          {{ $t('spaceAPITitle') }}
        </p>
        <p class="text-body-1 greytext--text d-none d-sm-block">
          {{ $t('spaceAPIText') }}
        </p>
      </v-col>
    </v-row>
    <v-row
      v-if="accessTokens.length > 0 && !loadingData"
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="(token, index) in accessTokens"
          :key="index"
          :ripple="false"
          data-testid="access-token-card"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="11"
                align-self="center"
                class="px-6"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ token.name }}
                </v-card-text>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list" />
                </v-menu>
              </v-col>    
              <v-col
                v-if="generatedTokenId == token.id && generatedToken != ''"
                cols="12"
                md="11"
                class="px-6 py-3"
              >
                <span
                  ref="generatedToken"
                  class="greytext--text"
                >{{ generatedToken }}</span><v-btn
                  elevation="0"
                  :ripple="false"
                  class="no-hover accent--text text-none"
                  text
                  @click="copyToken"
                >
                  {{ $t('copy') }}
                </v-btn>
              </v-col>                        
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="12"
                md="11"
                class="px-6"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ token.name }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list" />
                </v-menu>
              </v-col>
              <v-col
                v-if="generatedTokenId == token.id && generatedToken != ''"
                cols="12"
                md="11"
                class="px-6 py-3"
              >
                <span
                  ref="generatedToken"
                  class="greytext--text"
                >{{ generatedToken }}</span><v-btn
                  elevation="0"
                  :ripple="false"
                  class="no-hover accent--text text-none"
                  text
                  @click="copyToken"
                >
                  {{ $t('copy') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>   
      </v-col>
    </v-row>
    <PlusButtonWithLink
      data-testid="generate-new-access-token-button"
      rounded="xxl"
      :link="link"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import { getPersonalAccessTokens } from '../../api/spaceApi'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'

export default {
    components: {
       PlusButtonWithLink,
       AlertMessages
    },
        mixins: [repeatedMethodsMixin],

    data(){
        return{
            valid: true,
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            accessTokens: [],
            link: {title: i18n.t('generateAccessTokenTitle'), route: '/space/api/generate-token'},
            generatedToken: '',
            generatedTokenId: 0
        }
    },
    async created(){
      if(this.$route.params.successfullyGeneratedAccessToken){ 
        this.alertType = 'success'    
        this.alertMsg = i18n.t('generateAccessTokenSuccess')
        this.alertValue = true
        this.generatedToken = this.$route.params.token
        this.generatedTokenId = this.$route.params.id
      }
      this.loadingData = true
      await this.getPersonalAccessTokens();
      this.loadingData = false
    },
    methods:{
        async getPersonalAccessTokens(){
            try {
                const response = await getPersonalAccessTokens(this.spaceId)
                if(response.status){
                    if(response.status == 200) {
                        this.accessTokens = response.data.meta.tokens;
                        this.accessTokens.reverse()
                    }
                }            
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }            
            }
         },
         copyToken(){
            const el = document.createElement('textarea');  
            el.value = this.$refs.generatedToken[0].innerText
            document.body.appendChild(el);                          
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);
            this.alertType = 'success'    
            this.alertMsg = i18n.t('copyAccessTokenSuccess')
            this.alertValue = true
         }
    }
}
</script>